<template>
  <div class="lv-assignment-start-page">
    <LvText h3 bold class="mb-20">{{ title }}</LvText>
    <ContentChipsList v-if="systemSubclasses.length > 0" :chips="systemSubclasses" class="mb-20" />
    <LvText h4>{{ _quesNumber }}</LvText>
    <div class="lv-assignment-start-page__content-wrap">
      <ListCard white noPadding>
        <ListCardItem v-if="dateTitle && date" row type="text" :textContent="date">
          <template v-slot:title>
            <div class="list-card-item_title mr-8">
              <LvText h4 lightGray>{{ $t(dateTitle) }}</LvText>
            </div>
          </template>
        </ListCardItem>
        <ListCardItem v-if="durationTitle && duration" row type="text" :textContent="duration">
          <template v-slot:title>
            <div class="list-card-item_title mr-8">
              <LvText h4 lightGray>{{ $t(durationTitle) }}</LvText>
            </div>
          </template>
        </ListCardItem>
        <ListCardItem
          v-if="avatarTitle1 && avatars1 && avatars1.length"
          row
          type="avatars"
          :avatars="avatars1"
        >
          <template v-slot:title>
            <div class="list-card-item_title mr-8">
              <LvText h4 lightGray>{{ $t(avatarTitle1) }}</LvText>
            </div>
          </template>
        </ListCardItem>
        <ListCardItem
          v-if="avatarTitle2 && avatars2 && avatars2.length"
          row
          type="avatars"
          :avatars="avatars2"
        >
          <template v-slot:title>
            <div class="list-card-item_title mr-8">
              <LvText h4 lightGray>{{ $t(avatarTitle2) }}</LvText>
            </div>
          </template>
        </ListCardItem>
        <slot name="slot" />
      </ListCard>
    </div>
    <div v-if="btnList" class="lv-assignment-start-page__spacer" aria-hidden="true" />
    <div v-if="btnList" class="lv-assignment-start-page__btn">
      <WsButton001
        v-for="(btn, btnIndex) in btnList"
        :key="btnIndex"
        width-stretch
        :outLine="btn.outLine"
        class="mb-10"
        @click="btnClick(btn.value)"
      >
        {{ $t(btn.textLabel) }}
      </WsButton001>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    systemSubclasses: {
      type: Array,
      default() {
        return [];
      },
    },
    quesNumber: {
      type: Number,
      default: 0,
    },
    dateTitle: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    avatarTitle1: {
      type: String,
      default: '',
    },
    avatars1: {
      type: Array,
      default() {
        return [];
      },
    },
    avatarTitle2: {
      type: String,
      default: '',
    },
    avatars2: {
      type: Array,
      default() {
        return [];
      },
    },
    btnList: {
      type: Array,
    },
    durationTitle: {
      type: String,
    },
    duration: {
      type: String,
    },
  },
  computed: {
    _quesNumber() {
      return this.$t('共{number}題', { number: this.quesNumber });
    },
  },
  methods: {
    btnClick(btnValue) {
      this.$emit('btn-click', btnValue);
    },
  },
};
</script>
